import { BRAND_LIST } from 'typings'
import * as Typings from '../typings'

const MalaysiaLocale: Typings.LocaleType = {
  REGION: Typings.RegionGroupNames.SOUTH_EAST_ASIA,
  CODE: 'my',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Malaysia',
  SHORT_NAME: 'MY',

  DISPLAY_NAME: 'Malaysia (English)',
  DISPLAY_COUNTRY: 'Malaysia',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 4.2105,
    INITIAL_LONGITUDE: 101.9758,
    INITIAL_ZOOM: 6,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/my/en/',

  MAP_URL: 'https://www.uniqlo.com/my/shop/',
  // MAP_MOBILE_URL: '',

  TERMS_OF_USE_URL:
    'https://faq-my.uniqlo.com/pkb_Home_UQ_MY?id=kA32t0000004C9N&l=en_US&c=category_uq_sg_my%3AUQMY_C6&fs=Search&pn=1',
  PRIVACY_POLICY_URL:
    'https://faq-my.uniqlo.com/pkb_Home_UQ_MY?id=kA37F000000YMDn&l=en_US&c=category_uq_sg_my%3AUQMY_C6_3&fs=Search&pn=1',

  CONTACT_US_URL: 'https://faq-my.uniqlo.com/',

  POSTCODE_FORMAT: /[0-9]{5}/g,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  AM_FORMAT: ' AM',
  PM_FORMAT: ' PM',

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
  CMS_ENABLED: {
    [BRAND_LIST.UQ]: true,
  },
}

export default MalaysiaLocale
